import { SCREEN_WIDTH, SCREEN_HEIGHT } from "./constants";

const getButtonModalWidth = ( multiplier = 0.3) => {
  return SCREEN_WIDTH > SCREEN_HEIGHT
    ? SCREEN_WIDTH * multiplier
    : SCREEN_HEIGHT * multiplier;
};

export { getButtonModalWidth };
